import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import type { PrecisionValue } from '@fourthwall/module-analytics'

dayjs.extend(utc)

const formatToDateString = (date: Dayjs) =>
  date.format('YYYY-MM-DDTHH:mm:ssZ').replace('+00:00', 'Z')

export const getFrom = (now: Dayjs, range: number) => {
  if (range === 7) {
    return formatToDateString(now.subtract(7 - 1, 'days').startOf('day'))
  }

  if (range === 30) {
    return formatToDateString(now.subtract(30 - 1, 'days').startOf('day'))
  }

  return formatToDateString(now.startOf('day'))
}

export const getTo = (now: Dayjs) => formatToDateString(now.endOf('day'))

export const getPrecision = (range: number) => {
  if (range === 1) {
    return 'HOUR'
  }

  return 'DAY'
}

export const getRangeQueryParam = (range: number) => {
  if (range === 7) {
    return 'last7days'
  }

  if (range === 30) {
    return 'last30days'
  }

  return 'today'
}

export const getDateFormat = (precision: PrecisionValue) => {
  return precision === 'HOUR' ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY'
}
